import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Button,
  Label,
  makeStyles,
  tokens,
  useToastController,
  useId,
  Toaster,
} from "@fluentui/react-components";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import {
  getAssetDetailById,
  getAssetValuationDetailById,
  getAssetValuationsListItems,
} from "../../../../redux/Case/assetSlice";
import CaseNavList from "../CaseNavList";
import CaseForm from "../CaseForm";
import CaseList from "../CaseList";
import ContentLoader from "../../../../components/Loader/ContentLoader";
import ModalDialog from "../../../../components/ModalDialog";
import CaseDetailDrawer from "../CaseDetailDrawer";
import { useToastMessage } from "../../../../components/ToastMessage/ToastMessage";
import NoDataFound from "../../../../components/NoDataFound/noDataFound";

const useStyles = makeStyles({});

function AssetValuations({ tab }: { tab: string }) {
  const navigate = useNavigate();
  const styles = useStyles();
  const { showToast, toasterId } = useToastMessage();
  const { clientId, case_type, action, caseId, subItemId } = useParams();
  const dispatch: AppDispatch = useDispatch();
  const [currentRecord, setCurrentRecord] = useState(1);

  const formSettingsObj = useSelector((state: RootState) => state.formSettings);
  const assets = useSelector((state: RootState) => state.assets);
  const dialogModalOptions = useSelector((state: RootState) => state.dialog);

  const caseType = case_type || "";
  const [isOpen, setIsOpen] = useState(false);
  const handleDetailPopup = (action: boolean) => {
    setIsOpen(action);
  };
  useEffect(() => {
    if (caseId && clientId) {
      dispatch(getAssetDetailById({ id: caseId, customerId: clientId }));
      dispatch(
        getAssetValuationsListItems({ id: caseId, customerId: clientId })
      );
    }
  }, [caseId, clientId, dispatch]);

  const valuationId = subItemId || assets.valuations.listItems[0]?.valuation_id;

  useEffect(() => {
    if (!caseId || !valuationId) return;
    if (action === "view") {
      navigate(
        `/clients/${clientId}/assets/${case_type}/${caseId}/valuations/${valuationId}/valuation/view`
      );
    } else if (action === "add") {
      navigate(`/clients/${clientId}/assets/${case_type}/${caseId}/valuation/add`);
    } else if (action === "edit") {
      navigate(
        `/clients/${clientId}/assets/${case_type}/${caseId}/valuations/${valuationId}/valuation/edit`
      );
    } else {
      navigate(
        `/clients/${clientId}/assets/${case_type}/${caseId}/valuations/${valuationId}/valuation/view`
      );
    }
  }, [
    clientId,
    case_type,
    action,
    caseId,
    assets.valuations.listItems,
    valuationId,
    navigate,
    tab,
  ]);

  useEffect(() => {
    if (subItemId) {
      dispatch(getAssetValuationDetailById(subItemId));
    }
  }, [subItemId, dispatch, assets.valuations.listItems]);

  return (
    <div>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      <CaseNavList
        subItem="valuations"
        section="assets"
        tab={tab}
        caseType={caseType}
        caseDetail={assets?.valuations.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <div className="case_container_flex">
        <CaseForm
          mode={action || ""}
          section="assets"
          caseType={caseType}
          caseDetail={assets?.valuations.activeItem}
          caseItemList={assets?.valuations.listItems}
          tab={tab}
          notify={showToast}
          subItem="valuations"
          currentRecord={currentRecord}
          setCurrentRecord={setCurrentRecord}
        />
        <div>
          {assets?.valuations.listLoading ? (
            <ContentLoader />
          ) : (
            <>
              {assets?.valuations.listItems.length > 0 && (
                <CaseList
                  module="valuations"
                  data={assets?.valuations.listItems}
                  activeItem={assets?.valuations.activeItem}
                  section="assets"
                  activeTab={tab}
                  currentRecord={currentRecord}
                  setCurrentRecord={setCurrentRecord}
                />
              )}
              {!action && assets?.valuations.listItems.length === 0 && (
                <NoDataFound />
              )}
            </>
          )}
        </div>
      </div>
      <CaseDetailDrawer
        isOpen={isOpen}
        caseDetail={assets?.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <ModalDialog options={dialogModalOptions} />
    </div>
  );
}

export default AssetValuations;
